var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliteMind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_39550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8243 9.76953L8.82422 13.729",
    stroke: "#000000",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33882 7.60128C3.88949 7.49508 2.87127 6.80278 2.71765 5.45312",
    stroke: "#000000",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76822 11.5156C2.31107 11.8898 1.94657 12.7379 1.82849 13.4173",
    stroke: "#000000",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8805 11.5156C15.3376 11.8898 15.7021 12.7379 15.8202 13.4173",
    stroke: "#000000",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.611 7.63135C16.8503 8.26953 16.9852 8.97943 16.9852 9.69723C16.9852 11.0222 16.5258 12.6102 15.7978 13.422C15.8059 13.5226 15.81 13.6244 15.81 13.7271C15.81 15.7326 14.2439 17.3583 12.3121 17.3583C10.3802 17.3583 8.81415 15.7326 8.81415 13.7271C8.81415 15.7326 7.24774 17.3583 5.31588 17.3583C3.38403 17.3583 1.81795 15.7326 1.81795 13.7271C1.81795 13.6244 1.82207 13.5226 1.83013 13.422C1.10214 12.6102 0.642822 11.0222 0.642822 9.69723C0.642822 7.89174 1.49566 6.13629 2.71902 5.44626C2.70728 5.33328 2.70126 5.21853 2.70126 5.10233C2.70126 3.35013 4.06962 1.92969 5.75757 1.92969C6.52469 1.92969 7.22579 2.22306 7.76245 2.70762",
    stroke: "#000000",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4614 2.38594L13.1172 0.793141C13.1543 0.703219 13.2419 0.644531 13.3391 0.644531C13.4363 0.644531 13.524 0.703219 13.5611 0.793141L14.2169 2.38594C14.478 3.02002 14.9815 3.52353 15.6156 3.78462L17.2084 4.44049C17.2984 4.4775 17.357 4.56514 17.357 4.66239C17.357 4.75964 17.2984 4.84727 17.2084 4.88429L15.6156 5.54016C14.9815 5.80125 14.478 6.30476 14.2169 6.93884L13.5611 8.53164C13.524 8.62155 13.4363 8.68025 13.3391 8.68025C13.2419 8.68025 13.1543 8.62155 13.1172 8.53164L12.4614 6.93884C12.2003 6.30476 11.6968 5.80125 11.0627 5.54016L9.46989 4.88429C9.37998 4.84727 9.32129 4.75964 9.32129 4.66239C9.32129 4.56514 9.37998 4.4775 9.46989 4.44049L11.0627 3.78462C11.6968 3.52353 12.2003 3.02002 12.4614 2.38594Z",
    stroke: "#000000",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_39550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliteMind);
export default __webpack_public_path__ + "static/media/elite_mind.250d2dfb40eee3c604dd42da7ec868f3.svg";
export { ForwardRef as ReactComponent };